import { useMemo } from "react"
import { useToggle } from "usehooks-ts"

export function useIsOpen(initialValue: boolean = false) {
    const [isOpen, toggle, setOpen] = useToggle(initialValue)

    return useMemo(
        () => ({
            isOpen,
            open() {
                setOpen(true)
            },
            close() {
                setOpen(false)
            },
            toggle,
        }),
        [isOpen, toggle]
    )
}
